<div id="errorsDiv" class="errored-text" *ngIf="errorService.errors.length > 0">
  <div class="title"><img class="Form_Error" alt="" src="assets/images/img_transparent.png">&nbsp;
    <span>{{ 'error' | trackAndTranslate }}</span>
  </div>
  <ul>
    <li *ngFor="let error of errorService.errors">{{ error }}</li>
  </ul>
</div>
